/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  PayoutStatus,
  PayoutStatusState
} from '@/store/interfaces/payoutStatus';
import { RootState } from '@/store/interfaces/rootState';
import payoutStatus from '@/store/types/payoutStatus';
import { httpCommpix } from '@/util/HTTPCommpix';
import { AxiosError, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const namespaced = true;

const initialState = (): PayoutStatusState => {
  return {
    payoutStatusList: [],
  };
};

const state: PayoutStatusState = initialState();

const getters: GetterTree<PayoutStatusState, RootState> = {
  [payoutStatus.getters.GET_PAYOUT_STATUS_LIST]: state => {
    return state.payoutStatusList;
  },
};

const mutations: MutationTree<PayoutStatusState> = {
  reset: (state: any) => {
    const initialStateFields: any = initialState();
    Object.keys(initialStateFields).forEach((key: any) => {
      state[key] = initialStateFields[key];
    });
  },

  [payoutStatus.mutations.SET_PAYOUT_STATUS_LIST]: (
    state,
    states: Array<PayoutStatus>
  ) => {
    const payoutStatuses: Array<PayoutStatus> = states;

    state.payoutStatusList = payoutStatuses;
  },
};

const actions: ActionTree<PayoutStatusState, RootState> = {
  [payoutStatus.actions.PAYOUT_STATUS_LIST]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      httpCommpix
        .get('/payout-status')
        .then((res: AxiosResponse) => {
          commit(
            payoutStatus.mutations.SET_PAYOUT_STATUS_LIST,
            res.data
          );
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
